
const Host = require('server/js/lib/host.js');

import methods from './methods';


class AnyHost extends Host {
	constructor (options, ...rest) {
		super({
			methods,
		}, ...rest);
	}
}

module.exports = AnyHost;

